import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PreviewFrame from "../../Components/PreviewFrame";
import LoadingInComponent from "../../Components/LoadingInComponent";
import EventPreviewContent from "./EventPreviewContent";

const EventPreview = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  const eventInfo = state?.eventInfo;
  const customizations = state?.customizations;
  const monetary = state?.monetary;

  useEffect(() => {
    if (!eventInfo || !customizations || !monetary) {
      setError("Event data not found");
      return;
    }
  }, [customizations, eventInfo, monetary]);

  if (error) {
    return (
      <div className="flex flex-col h-screen justify-center items-center bg-gray-100">
        <p className="text-lg text-gray-500">{error}</p>
        <button
          onClick={() => navigate(-1)}
          className="px-4 py-2 mt-4 bg-blue-500 text-white rounded"
        >
          Go Back
        </button>
      </div>
    );
  }

  return (
    <PreviewFrame 
      data={eventInfo} 
      recordId={state?.recordId} 
      type={state.type}
      onClose={() => navigate(-1)}
      >
      {(currentView) => (
        <LoadingInComponent isLoading={false}>
          <EventPreviewContent
            eventInfo={eventInfo}
            customizations={customizations}
            view={currentView}
          />
        </LoadingInComponent>
      )}
    </PreviewFrame>
  );
};

export default EventPreview;